/**
 * Labstep
 *
 * @module components/ResourceLocation/Form/Create
 * @desc Createable ResourceLocation - Auto save on change
 */

import { fieldResourceLocationNameMultiple } from 'labstep-web/components/ResourceLocation/Form/fields';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type React from 'react';
import type { IResourceLocationFormCreateProps } from './types';

export const ResourceLocationFormCreate: React.FC<
  IResourceLocationFormCreateProps
> = ({ body, options }) => (
  <EntityCreateContainer
    batch
    entityName={ResourceLocation.entityName}
  >
    {({ create, status }): React.ReactElement => (
      <FormReusable
        autoFocus
        status={status}
        fields={[fieldResourceLocationNameMultiple]}
        onSubmit={(values): void => {
          create(
            (values as { names: string[] }).names.map(
              (name: string) => ({
                name,
                ...body,
              }),
            ),
            options,
          );
        }}
      />
    )}
  </EntityCreateContainer>
);
